// extracted by mini-css-extract-plugin
export default {"description":"tabs-bankid-tab_description","statusMessageContainer":"tabs-bankid-tab_statusMessageContainer","privacyPolicyLink":"tabs-bankid-tab_privacyPolicyLink"};